import { create } from "zustand";
import { persist } from "zustand/middleware";

// Create Zustand store with persist middleware
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
    }),
    {
      name: "user",
    }
  )
);

